import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { SectionHeader } from "@pentabd/ui";

import { InputDateControllerRow, MultiFileRow } from "@components";

import { AGREEMENT_FIELDS } from "../..";

export const AgreementDocument = () => {
  const { control, register, setValue } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <SectionHeader
        title={t("PROCUREMENT_CREATE.AGREEMENT.FORM.AGREEMENT_DOCUMENT.TITLE")}
      />

      <InputDateControllerRow
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.AGREEMENT_DOCUMENT.CONTACT_SIGN_DATE"
        control={control}
        register={{ ...register(AGREEMENT_FIELDS.CONTACT_SIGN_DATE) }}
        name={AGREEMENT_FIELDS.CONTACT_SIGN_DATE}
      />

      <InputDateControllerRow
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.AGREEMENT_DOCUMENT.PROJECT_COMPLETION_DATE"
        control={control}
        register={{ ...register(AGREEMENT_FIELDS.PROJECT_COMPLETION_DATE) }}
        name={AGREEMENT_FIELDS.PROJECT_COMPLETION_DATE}
      />

      <InputDateControllerRow
        label="PROCUREMENT_CREATE.AGREEMENT.FORM.AGREEMENT_DOCUMENT.EXTENDED_COMPLETION_DATE"
        control={control}
        register={{ ...register(AGREEMENT_FIELDS.EXTENDED_COMPLETION_DATE) }}
        name={AGREEMENT_FIELDS.EXTENDED_COMPLETION_DATE}
      />

      <MultiFileRow
        name={AGREEMENT_FIELDS.AGREEMENT_DOC_UPLOAD}
        control={control}
        setValue={setValue}
        register={register}
        fileDetails={["documentName", "date", "remarks", "memorialNo"]}
      />
    </>
  );
};
